export default __webpack_public_path__ + "static/media/checkmark.463f0a71.svg";